import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useRef, useEffect, FC } from 'react';

import { CallBlurType } from '@gem/call/constants';

import styles from './PreviewVideo.styles.m.css';

interface IPreviewVideoProps {
  videoStream: MediaStream;
  blurType: CallBlurType;
}

export const PreviewVideo: FC<IPreviewVideoProps> = observer((props) => {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.srcObject = props.videoStream;

      ref.current.onloadedmetadata = (): void => {
        ref.current?.play();
      };
    }
  }, [props.videoStream, props.blurType]);

  return (
    <video
      playsInline
      ref={ref}
      className={classNames(styles.video)}
    />
  );
});
